
/**
 * Maps platform-specific content types to universal categories.
 * 
 * @param {string} platform - 'instagram', 'facebook', or 'youtube'
 * @param {string} type - The raw media_type or derived type from the platform
 * @returns {string} - Universal category: 'Short Video', 'Long Video', 'Static Image', 'Collection', 'Text/Link', 'Other'
 */
export const normalizeContentType = (platform, type) => {
    if (!type) return 'Other';
    const rawType = type.toUpperCase();
    const plat = platform.toLowerCase();

    // --- INSTAGRAM ---
    if (plat === 'instagram') {
        if (rawType === 'REEL') return 'Short Video';
        if (rawType === 'VIDEO') return 'Long Video'; // IG Videos are now mostly Reels, but older/longer ones can be 'Video'
        if (rawType === 'IMAGE') return 'Static Image';
        if (rawType === 'CAROUSEL_ALBUM' || rawType === 'CAROUSEL') return 'Collection';
        if (rawType === 'STORY') return 'Short Video'; // Stories are short video/image, but often treated as ephemeral video
    }

    // --- FACEBOOK ---
    if (plat === 'facebook') {
        // FB "Status" logic usually comes from status_type, simplified here:
        if (rawType === 'REEL') return 'Short Video';
        if (rawType === 'VIDEO') return 'Long Video';
        if (rawType === 'PHOTO') return 'Static Image';
        if (rawType === 'ALBUM') return 'Collection';
        if (rawType === 'STATUS' || rawType === 'LINK' || rawType === 'NOTE') return 'Text/Link';
    }

    // --- YOUTUBE ---
    if (plat === 'youtube') {
        if (rawType === 'SHORTS') return 'Short Video';
        if (rawType === 'REGULAR' || rawType === 'VIDEO') return 'Long Video';
    }

    return 'Other';
};
